const WebAuthn = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="8" fill="black" />
    <path
      d="M21.2003 10.7793V17.7331H14.2465V10.7793H21.2003ZM24.7262 7.25342H10.7207V21.2589H24.7262V7.25342Z"
      fill="#FF44DD"
    />
    <path
      d="M15.9728 24.7465V16.0068H7.23307V24.7465H15.9728Z"
      fill="#635DFF"
    />
    <path
      d="M10.33 19.1037L12.7917 21.5937L18.9542 15.5012L16.4926 13.0112L10.33 19.1037Z"
      fill="#3EC6EB"
    />
    <path
      d="M11.561 22.0993C10.5941 22.0993 9.81027 21.3155 9.81027 20.3486C9.81027 19.3817 10.5941 18.5979 11.561 18.5979C12.5278 18.5979 13.3116 19.3817 13.3116 20.3486C13.3116 21.3155 12.5278 22.0993 11.561 22.0993Z"
      fill="black"
    />
    <path
      d="M17.7234 16.0069C16.7566 16.0069 15.9727 15.2231 15.9727 14.2562C15.9727 13.2893 16.7566 12.5055 17.7234 12.5055C18.6903 12.5055 19.4741 13.2893 19.4741 14.2562C19.4741 15.2231 18.6903 16.0069 17.7234 16.0069Z"
      fill="white"
    />
  </svg>
);

export default WebAuthn;
